"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfZipCodeDto = instanceOfZipCodeDto;
exports.ZipCodeDtoFromJSON = ZipCodeDtoFromJSON;
exports.ZipCodeDtoFromJSONTyped = ZipCodeDtoFromJSONTyped;
exports.ZipCodeDtoToJSON = ZipCodeDtoToJSON;
exports.ZipCodeDtoToJSONTyped = ZipCodeDtoToJSONTyped;
/**
 * Check if a given object implements the ZipCodeDto interface.
 */
function instanceOfZipCodeDto(value) {
    if (!('zipCode' in value) || value['zipCode'] === undefined)
        return false;
    return true;
}
function ZipCodeDtoFromJSON(json) {
    return ZipCodeDtoFromJSONTyped(json, false);
}
function ZipCodeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'zipCode': json['zipCode'],
    };
}
function ZipCodeDtoToJSON(json) {
    return ZipCodeDtoToJSONTyped(json, false);
}
function ZipCodeDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'zipCode': value['zipCode'],
    };
}
//# sourceMappingURL=ZipCodeDto.js.map